import {AppDispatch} from '../store';
import {CategoryType} from '../types/CategoryType';
import {getJsonData, postJsonData} from './requests';

export const getAllActiveCategories = (dispatch: AppDispatch) => {
    const url = 'api/1.0/categories/active';
    return getJsonData(url, dispatch);
};

export const getAllCategories = (dispatch: AppDispatch) => {
    const url = 'api/1.0/categories/planit';
    return getJsonData(url, dispatch);
};

export const updateCategories = (categories: Array<CategoryType>, dispatch: AppDispatch) => {
    const url = 'api/1.0/categories';
    return postJsonData(url, JSON.stringify(categories), dispatch);
};
